import { HeaderGridRow } from 'ui/indexPages/tables/grid';
import { SortableHeaderCell } from './TableCells/SortableHeaderCell';
import {
  FULL_NAME,
  ORGANIZATION_ROLE,
  PROJECT_MEMBERSHIPS,
  TFA,
  LAST_LOGIN_AT,
  CREATED_AT,
} from './constants';
import { SelectionHeaderCell } from './TableCells/SelectionHeaderCell';

const createColumns = (isMfaAvailable: boolean) => [
  {
    label: 'Name',
    name: FULL_NAME,
  },
  {
    label: 'Organization role',
    name: ORGANIZATION_ROLE,
  },
  {
    label: 'Project membership',
    name: PROJECT_MEMBERSHIPS,
  },
  ...(isMfaAvailable
    ? [
        {
          label: 'MFA',
          name: TFA,
        },
      ]
    : []),
  {
    label: 'Latest login',
    name: LAST_LOGIN_AT,
  },
  {
    label: 'Created',
    name: CREATED_AT,
  },
];

export const MembersTableHeader = ({
  currentPageIds,
  gridLayout,
  isMfaAvailable,
}: {
  currentPageIds: string[];
  gridLayout: string;
  isMfaAvailable: boolean;
}) => {
  const columns = createColumns(isMfaAvailable);

  return (
    <HeaderGridRow gridLayout={gridLayout}>
      <SelectionHeaderCell currentPageIds={currentPageIds} />
      {columns.map((column: any) => (
        <SortableHeaderCell key={column.name} name={column.name} label={column.label} />
      ))}
      <div role="columnheader" />
    </HeaderGridRow>
  );
};
